//import update from 'immutability-helper';

const emptyState = {
  data: {}
}

const HelpReducer = (state = emptyState, action) => {
  switch (action.type) {
    case "HELP_INIT": {
      let newData = JSON.parse(JSON.stringify(action.payload));
      return {...state, data: newData};
    }
    default: {
      return state
    }
  }
}

export default HelpReducer